/**
 * @ngdoc directive
 * @name interviews
 *
 * @description
 * Articles column layout
 */
module.directive('interviews', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            content: '='
        },
        controller: ['$scope', function ($scope) {
            $scope.content.forEach(function (interview) {
                interview.created = new Date(parseInt(interview.created)*1000);
            });
        }],
        template:
                '<div class="aqua-interviews">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-interviews--title">{{label}}</span></h2>' +

                '    <div class="grid grid-gutter grid-b2c-gutter">' +

                '      <div class="aqua-interviews--item grid-4 grid-4-m grid-12-s grid grid-v" ng-repeat="interview in content">' +
                '        <a ui-sref="section({id:interview.nid, slug: \'--\' + (interview.title | slugify)})" class="aqua-interviews--item-figure"><img class="aqua-interviews--item-picture" aqua-src="{{interview.field_image.src}}" alt="{{interview.field_image.alt}}" /></a>' +
                '        <h3 class="aqua-interviews--item-title"><a ui-sref="section({id:interview.nid, slug: \'--\' + (interview.title | slugify)})">{{interview.title}}</a></h3>' +
                '        <p class="aqua-interviews--item-category">{{interview.field_category_news}}</p>' +
                '        <p class="aqua-interviews--item-date">Le {{interview.created | date:\'dd/MM/yyyy\'}}</p>' +
                '        <p class="aqua-interviews--item-text">{{interview.field_teaser}}</p>' +
                '        <p class="aqua-interviews--item-more">' +
                '          <a class="aqua-interviews--item-more--link" ui-sref="section({id:interview.nid, slug: \'--\' + (interview.title | slugify)})">{{ \'common.readMore\' | translate }}</a>' +
                '        </p>' +
                '      </div>' +

                '    </div>' +

                '  </div>' +
                '</div>'
    };
});